import { objectOf, arrayOf, anyOf } from "@altostra/type-validations";
import { string, nullOrUndefined, boolean, number, maybeString } from "@altostra/type-validations/lib/primitives";

export const isAlloysIntegrationsIntegrationIdBridgeResult = objectOf({
  bridge: objectOf({
    _id: string,
    ag_id: string,
    c_id: string,
    config: objectOf({
      account_name: string,
      access_token_created_at: string,
      ad_accounts: arrayOf(
        objectOf({
          id: string,
          name: string,
          custom_audiences: arrayOf(
            objectOf({
              id: string,
              name: string,
              data_type: string,
              status: anyOf(maybeString, nullOrUndefined),
            })
          ),
          additional_data: objectOf({
            isa_manager: boolean,
            manager_name: string,
            manager_id: number,
            isa_root: boolean,
          }),
        })
      ),
      allow_list: arrayOf(string),
      token_last_refreshed_at: string,
      api_access_exists: boolean,
    }),
    connected_at: string,
    connected_by_id: string,
    created_at: string,
    disconnected_at: anyOf(string, nullOrUndefined),
    disconnected_by_id: anyOf(string, nullOrUndefined),
    external_id: anyOf(maybeString, nullOrUndefined),
    integration_id: string,
    status: number,
    updated_at: string,
  }),
});
